import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { BaseIcon } from './index.elements';

export const Icon = styled(BaseIcon)<{ includeBanner: boolean }>(props => css`
  height: 100%;
  padding-top: ${props.includeBanner ? 0 : 8}px;
`);
